import * as _ from 'lodash';
import { Button, Content, Table } from 'rbx';
import * as React from 'react';
import { withRouter, IWithRouterProps } from '../../../utils/withRouter';
import { Link } from 'react-router-dom';

import RabbitStatsQuery from '../../../components/ops/RabbitStatsQuery';
import Accordion from '../../../components/ui/accordion/Accordion';
import Routing from '../../../Routing';
import { camelToTitle } from '../../../utils/helpers';
import { notification } from '../../../utils/notification';
import { RABBIT_POLLING_INTERVAL } from '../../OpsContainer';
import Pane from './../../../components/ui/Pane';
import DocumentsSync from './documents/DocumentsSync';
import IPlantModel from '../../../models/IPlantModel';
import DocumentsSyncText from './documents/DocumentsSyncText';
import FastReindexMutation from './documents/FastReindexMutation';
import { IIndeaxable, IndexableRow } from './indexables/IndexableRow';
import IndexCsvMutation from './indexables/IndexCsvMutation';
import IndexDocumentumDocumentsCsvMutation from './indexables/IndexDocumentumDocumentsCsvMutation';

interface IRouteParams {
    plantId: string;
}

interface IProps extends IWithRouterProps {
    plant: IPlantModel;
    s3FileCount: number;
    indexables: IIndeaxable[];
    partsCsv: { indexableCount: number; indexedCount: number };
    documentumCsvExists: boolean;
    refetch?: () => void;
    refetchPlant?: () => void;
}

interface IState {
    dryRun?: boolean;
    onlyErrored?: boolean;
    forceSplit?: boolean;
    forceIndex?: boolean;
    forceNormalize?: boolean;
    forceExtract?: boolean;
    forceOcr?: boolean;
}

class PlantOnboarding extends React.Component<IProps, IState> {
    public state: IState = {
        dryRun: false,
        onlyErrored: false,
        forceSplit: false,
        forceIndex: false,
        forceNormalize: false,
        forceExtract: false,
        forceOcr: false,
    };

    private refetchData = async () => {
        const { refetch, refetchPlant } = this.props;
        if (refetch) {
            const res: any = await refetch();
            if (res && !res.errors) {
                notification.success('Successfully updated');
            }
        }
        if (refetchPlant) {
            await refetchPlant();
        }
    };

    private paneActions = () => {
        const { plantId } = this.props.match.params;
        return (
            <>
                <Link className="button is-primary" to={Routing.PLANT_TAGS.getPath(plantId)}>
                    View Tags
                </Link>
                <Button onClick={this.refetchData}>Reload</Button>
            </>
        );
    };

    private onOptsChange = (context: React.SyntheticEvent<HTMLInputElement>) => {
        const { name, checked } = context.currentTarget;
        const prop: any = {};
        prop[name] = checked;
        this.setState(prop);
    };

    public render() {
        const {
            plant,
            s3FileCount,
            indexables,
            partsCsv,
            documentumCsvExists,
        } = this.props;
        const plantS3Folder = plant.s3Folder;
        const { plantId } = this.props.match.params;

        const TableBody = Table.Body as any;
        const title = `Spindex document overview for ${plantS3Folder}`;
        const sortOrder = ['tags', 'pnid', 'spacy', 'sap_po', 'green', 'yellow', 'red'];
        const advancedOptions = [
            'dryRun',
            'onlyErrored',
            'forceSplit',
            'forceIndex',
            'forceNormalize',
            'forceExtract',
            'forceOcr',
        ];

        const sortedIndexables = _.sortBy(
            indexables.map(i => {
                const indx = _.indexOf(sortOrder, i.name);
                return {
                    ...i,
                    dryRun: this.state.dryRun,
                    forceSplit: this.state.forceSplit,
                    onlyErrored: this.state.onlyErrored,
                    forceIndex: this.state.forceIndex,
                    forceNormalize: this.state.forceNormalize,
                    forceExtract: this.state.forceExtract,
                    forceOcr: this.state.forceOcr,
                    sort: indx >= 0 ? indx + 1 : undefined,
                };
            }),
            'sort',
        );

        return (
            <Pane actionButtons={this.paneActions()} title={title}>
                <Content>
                    <DocumentsSync plantS3Folder={plantS3Folder} s3FileCount={s3FileCount} />
                    {s3FileCount > 0 && (
                        <>
                            <table className="table is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>File Type</th>
                                        <th># Files Indexable</th>
                                        <th># Files Indexed</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {sortedIndexables.map((indexable: IIndeaxable) => {
                                        return (
                                            <IndexableRow
                                                key={indexable.name}
                                                plantS3Folder={plantS3Folder}
                                                indexable={indexable}
                                            />
                                        );
                                    })}
                                </tbody>

                                {partsCsv && (
                                    <>
                                        <thead>
                                            <tr>
                                                <th />
                                                <th>Rows in CSV</th>
                                                <th># of tags in plant</th>
                                                <th />
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>equipment</td>
                                                <td>{partsCsv.indexableCount} </td>
                                                <td>{partsCsv.indexedCount}</td>
                                                <td>
                                                    <IndexCsvMutation plantId={plantId} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </>
                                )}

                                {documentumCsvExists && (
                                    <>
                                        <thead>
                                            <tr>
                                                <th />
                                                <th />
                                                <th />
                                                <th />
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>documentum csv</td>
                                                <td />
                                                <td />
                                                <td>
                                                    <IndexDocumentumDocumentsCsvMutation
                                                        plantId={plantId}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </>
                                )}
                            </table>

                            <h4>Advanced Indexing Options:</h4>
                            {advancedOptions.map((advOpt: string) => {
                                return (
                                    <label className="checkbox mr-15" key={advOpt}>
                                        <input
                                            type="checkbox"
                                            className="mr-05"
                                            name={advOpt}
                                            onChange={this.onOptsChange}
                                            checked={this.state[advOpt]}
                                        />
                                        {camelToTitle(advOpt) +
                                            (advOpt === 'forceOcr' ? ' (costs $$$)' : '')}
                                    </label>
                                );
                            })}
                            <FastReindexMutation indexFileOptions={this.state} plantId={plantId} />
                            <Accordion title="RABBIT STATS">
                                <RabbitStatsQuery pollInterval={RABBIT_POLLING_INTERVAL} />
                            </Accordion>
                            <DocumentsSyncText plantS3Folder={plantS3Folder} />
                        </>
                    )}
                </Content>
            </Pane>
        );
    }
}

export default withRouter(PlantOnboarding);
